import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider } from './context/Context';
import SocketProvider from './context/SocketContext';
import SocketNFCProvider from './context/SocketNFC';
import { BrowserRouter } from 'react-router-dom';
import { darkTheme } from './theme/theme';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

// Touch screens leave the CSS :hover state stuck on the last-tapped control
// (there is no pointer to move away), so hover styling lingers over buttons and
// cards — even selected ones. Hover is not meaningful on a touch device, so we
// strip every :hover rule as Emotion/MUI generates it. This removes all `sx`
// and default MUI hover styling app-wide, on every device, without depending on
// @media (hover). Base and selected/active styles live in the non-hover rule,
// so they are left completely untouched.
const stripHoverPlugin = (element) => {
  if (element.type === 'rule') {
    const selector = Array.isArray(element.props)
      ? element.props.join(',')
      : String(element.value || '');
    if (selector.includes(':hover')) {
      element.children = [];
      element.return = '';
    }
  }
};

const emotionCache = createCache({
  key: 'css',
  prepend: true,
  stylisPlugins: [stripHoverPlugin],
});

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <CacheProvider value={emotionCache}>
    <ThemeProvider theme={darkTheme}>
      <AppProvider>
        <SocketProvider>
          <SocketNFCProvider>
            <CssBaseline />
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </SocketNFCProvider>
        </SocketProvider>
      </AppProvider>
    </ThemeProvider>
  </CacheProvider>
);
